import { SiteHealthMetricData, SiteCategories, MetricDataContainer } from "../scripts/site-health.entities";
import { Appendix } from "../../../../shared/entities/scripts/appendix";
import { Study } from "../../../../shared/entities/scripts/study";
import { SiteInfo } from "../../sites/shared/sites.entities";
import { ISiteInfo } from "../../data-completeness/scripts/data-completeness.page";
import { plainToClass } from "class-transformer";




export class SiteHealthPage {

    siteInfoList: SiteInfo[];
    siteInfoMap: Map<number, SiteInfo>;
    tableByTrial: any;
    tableByPlatform: any;
    tableBySite: any;

    validSites: SiteHealthMetricData[];
    aggregatedSites: SiteHealthMetricData[];
    aggregatedPlatforms: SiteHealthMetricData[];

    selectedGrouping: string = "byTrial";
    categoryState: Record<string, boolean> = {};
    categoryColumnIndexesByTrial: Record<string, { compact: number[], expanded: number[] }>;
    categoryColumnIndexesBySite: Record<string, { compact: number[], expanded: number[] }>;
    categoryColumnIndexesByPlatform: Record<string, { compact: number[], expanded: number[] }>;

    data: {
        Sites: SiteHealthMetricData[],
        SitesBySite: SiteHealthMetricData[],
        SitesByPlatform: SiteHealthMetricData[],
        Categories: { Name: string; TitleInfo: string; SafeName: string; Metrics: { Name: string; VariableName: string; TitleInfo: string; ValueScaling: string; IsPercent: boolean; ScalingValue1?: number; ScalingValue2?: number; ScalingValue3?: number; ScalingValue4?: number; }[] }[]
    };

    metricMinMaxCache: Map<string, { min: number, max: number }> = new Map();

    constructor(metricDataJson: MetricDataContainer, categories: { Name: string; TitleInfo: string; SafeName: string; Metrics: { Name: string; TitleInfo: string; VariableName: string; ValueScaling: string; IsPercent: boolean; ScalingValue1?: number; ScalingValue2?: number; ScalingValue3?: number; ScalingValue4?: number; }[] }[], siteInfoJson: any) {
        const sites = metricDataJson.site_tracking_nogroup || [];
        const sitesBySite = metricDataJson.site_tracking_bysite || [];
        const sitesByPlatform = metricDataJson.site_tracking_byplatform || [];

        this.siteInfoList = SiteInfo.Parse(siteInfoJson);
        this.siteInfoMap = new Map<number, SiteInfo>();
        this.siteInfoList.forEach((site: SiteInfo) => {
            if (!this.siteInfoMap.has(site.SiteNumber)) { this.siteInfoMap.set(site.SiteNumber, site); }
        });

        this.populateNames(sites, this.siteInfoList, 'nogroup');
        this.populateNames(sitesBySite, this.siteInfoList, 'bysite');
        this.populateNames(sitesByPlatform, this.siteInfoList, 'byplatform');

        this.data = {
            Sites: sites,
            SitesBySite: sitesBySite,
            SitesByPlatform: sitesByPlatform,
            Categories: categories
        };

        this.calculateMinMaxForMetrics(sites, categories);

        ////Exclude if any metric is null or undefined
        //this.validSites = this.data.Sites.filter(site => {
        //    return this.data.Categories.every(category =>
        //        category.Metrics.every(metric => site[metric.VariableName] !== null && site[metric.VariableName] !== undefined)
        //    );
        //});
        //this.aggregatedSites = this.data.SitesBySite.filter(site => {
        //    return this.data.Categories.every(category =>
        //        category.Metrics.every(metric => site[metric.VariableName] !== null && site[metric.VariableName] !== undefined)
        //    );
        //});
        //this.aggregatedPlatforms = this.data.SitesByPlatform.filter(site => {
        //    return this.data.Categories.every(category =>
        //        category.Metrics.every(metric => site[metric.VariableName] !== null && site[metric.VariableName] !== undefined)
        //    );
        //});

        ////Exclude only if every metric is null or undefined
        //this.validSites = this.data.Sites.filter(site => {
        //    return this.data.Categories.some(category =>
        //        category.Metrics.some(metric => site[metric.VariableName] !== null && site[metric.VariableName] !== undefined)
        //    );
        //});
        //this.aggregatedSites = this.data.SitesBySite.filter(site => {
        //    return this.data.Categories.some(category =>
        //        category.Metrics.some(metric => site[metric.VariableName] !== null && site[metric.VariableName] !== undefined)
        //    );
        //});
        //this.aggregatedPlatforms = this.data.SitesByPlatform.filter(site => {
        //    return this.data.Categories.some(category =>
        //        category.Metrics.some(metric => site[metric.VariableName] !== null && site[metric.VariableName] !== undefined)
        //    );
        //});

        this.validSites = this.data.Sites;  
        this.aggregatedSites = this.data.SitesBySite;
        this.aggregatedPlatforms = this.data.SitesByPlatform;

        $(() => {
            this.populateDropdowns(this.validSites, 'byTrial');
            this.populateDropdowns(this.aggregatedSites, 'bySite');
            this.populateDropdowns(this.aggregatedPlatforms, 'byPlatform');
            
            const { dataTable, categoryColumnIndexes } = this.initializeTable('bytrial', this.validSites, categories);
            this.tableByTrial = dataTable;
            this.categoryColumnIndexesByTrial = categoryColumnIndexes;

            const bySiteResult = this.initializeTable('bysite', this.aggregatedSites, categories);
            this.tableBySite = bySiteResult.dataTable;
            this.categoryColumnIndexesBySite = bySiteResult.categoryColumnIndexes;

            const byPlatformResult = this.initializeTable('byplatform', this.aggregatedPlatforms, categories);
            this.tableByPlatform = byPlatformResult.dataTable;
            this.categoryColumnIndexesByPlatform = byPlatformResult.categoryColumnIndexes;

            this.bindDropdownEvents();
            this.bindViewSwitching();

            $(document).on('click', '.toggle-category', (e) => {
                const btn = $(e.currentTarget);
                const category = btn.data('category');
                const expandedState = !this.categoryState[category]; 
                this.categoryState[category] = expandedState; 

                btn.toggleClass('expanded', expandedState);
                btn.find('.toggle-icon').toggleClass('rotate-x', expandedState);

                const activeTable = this.getActiveTable();
                const activeCategoryIndexes = this.getActiveCategoryIndexes();

                if (activeTable && activeCategoryIndexes[category]) {
                    activeCategoryIndexes[category].expanded.forEach(i => activeTable.column(i).visible(expandedState));
                    activeCategoryIndexes[category].compact.forEach(i => activeTable.column(i).visible(!expandedState));
                    activeTable.columns.adjust().draw(false);
                    if (activeTable.fixedColumns) activeTable.fixedColumns().relayout();
                }
            });

            $('#expand-all').on('click', () => {
                const activeTable = this.getActiveTable();
                const activeCategoryIndexes = this.getActiveCategoryIndexes();
                Object.keys(activeCategoryIndexes).forEach(cat => {
                    this.categoryState[cat] = true;
                    activeCategoryIndexes[cat].expanded.forEach(i => activeTable.column(i).visible(true));
                    activeCategoryIndexes[cat].compact.forEach(i => activeTable.column(i).visible(false));
                });
                $('.toggle-category').addClass('expanded').find('.toggle-icon').addClass('rotate-x');
                activeTable.columns.adjust().draw(false);
            });

            $('#collapse-all').on('click', () => {
                const activeTable = this.getActiveTable();
                const activeCategoryIndexes = this.getActiveCategoryIndexes();
                Object.keys(activeCategoryIndexes).forEach(cat => {
                    this.categoryState[cat] = false;
                    activeCategoryIndexes[cat].expanded.forEach(i => activeTable.column(i).visible(false));
                    activeCategoryIndexes[cat].compact.forEach(i => activeTable.column(i).visible(true));
                });
                $('.toggle-category').removeClass('expanded').find('.toggle-icon').removeClass('rotate-x');
                activeTable.columns.adjust().draw(false);
            });
         
        });
    }

    private calculateMinMaxForMetrics(sites: SiteHealthMetricData[], categories: any[]): void {
        categories.forEach(category => {
            category.Metrics.forEach(metric => {
                const values = sites
                    .map(site => site[metric.VariableName])
                    .filter(v => v !== null && v !== undefined && !isNaN(v));
                
                if (values.length > 0) {
                    this.metricMinMaxCache.set(metric.VariableName, {
                        min: Math.min(...values),
                        max: Math.max(...values)
                    });
                }
            });
        });
    }

   

   
    private initializeTable(tableId: string, sites, categories): any {
        const table = document.getElementById(tableId)!;
        const categoryRow = table.querySelector(`tr#${tableId}-category-row`)!;
        const metricRow = table.querySelector(`tr#${tableId}-metric-row`)!;

        
        metricRow.innerHTML = '';

        const staticColumns = [{ title: 'Site', data: 'Site', className: "text-left font-size12" }];
        if (tableId === 'bytrial') staticColumns.push({ title: 'Trial', data: 'Appendix', className: "text-left font-size12" });
        if (tableId === 'byplatform') staticColumns.push({ title: 'Platform', data: 'Study', className: "text-left font-size12" });

        staticColumns.forEach(col => {
            const th = document.createElement('th');
            th.textContent = col.title;
            th.rowSpan = 2;
            categoryRow.appendChild(th);
          
        });
        // static in the category as they should always be visible 
        const finalColumns: any[] = [...staticColumns];
        const categoryColumnIndexes: Record<string, { compact: number[], expanded: number[] }> = {};

        categories.forEach(cat => {
            categoryColumnIndexes[cat.SafeName] = { compact: [], expanded: [] }; // keep track of which columns are the smaller ones and the larger

            //categories
            const thCategory = document.createElement('th');
            thCategory.colSpan = cat.Metrics.length * 2;
            thCategory.innerHTML = `<button class="btn btn-link p-0 toggle-category" data-category="${cat.SafeName}">${cat.Name} <i class="fas fa-plus toggle-icon"></i></button>`;
            thCategory.className = 'category text-center font-size12';
            thCategory.title = `${cat.TitleInfo}`;
            categoryRow.appendChild(thCategory);

            cat.Metrics.forEach(metric => {
                // expanded columns 
                finalColumns.push({
                    data: metric.VariableName,
                    CategoryName: cat.Name,
                    className: `metric-${cat.SafeName} text-center font-size12 heatmap-cell-expanded`,
                    visible: false,
                    orderable: true,
                    createdCell: (td: HTMLElement, cellData: number | null) => {
                        let displayValue = '';
                        if (cellData != null) {
                            displayValue = metric.IsPercent
                                ? `${Math.round(cellData * 100)}%`
                                : cellData.toFixed(2).replace(/\.00$/, '');
                        }
                        td.style.backgroundColor = this.getBackgroundColor(
                            cellData, 
                            metric.IsPercent, 
                            metric.ValueScaling,
                            metric.VariableName,
                            metric.ScalingValue1,
                            metric.ScalingValue2,
                            metric.ScalingValue3,
                            metric.ScalingValue4
                        );
                        td.innerHTML = `<span>${displayValue}</span>`;
                        td.title = `${metric.TitleInfo}: ${displayValue || 'No Data'}`;
                    }
                });
                const thExp = document.createElement('th');
                thExp.textContent = metric.Name;
                metricRow.appendChild(thExp);
                categoryColumnIndexes[cat.SafeName].expanded.push(finalColumns.length - 1);

                // onload smaller columns
                finalColumns.push({
                    data: metric.VariableName,
                    CategoryName: cat.Name,
                    className: `metric-${cat.SafeName} heatmap-cell`,
                    visible: true,
                    orderable: true,
                    createdCell: (td: HTMLElement, cellData: number | null) => {
                        const bg = this.getBackgroundColor(
                            cellData, 
                            metric.IsPercent, 
                            metric.ValueScaling,
                            metric.VariableName,
                            metric.ScalingValue1,
                            metric.ScalingValue2,
                            metric.ScalingValue3,
                            metric.ScalingValue4
                        );
                        td.style.backgroundColor = bg;
                        td.style.width = '40px';
                        td.innerHTML = '';
                        let displayValue = '';
                        if (cellData != null) {
                            displayValue = metric.IsPercent
                                ? `${Math.round(cellData * 100)}%`
                                : cellData.toFixed(2).replace(/\.00$/, '');
                        }
                        td.title = `${metric.TitleInfo}: ${displayValue || 'No Data'}`;
                    }
                });
                const thComp = document.createElement('th');
                thComp.className = 'compact-header'; 
                metricRow.appendChild(thComp);
                categoryColumnIndexes[cat.SafeName].compact.push(finalColumns.length - 1);
            });
        });

        const dataTable: any = $('#' + tableId).DataTable({
            dom: 'lrtip',
            data: sites,
            autoWidth: false,
            info: false,
            paging: false,
            searching: true,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: false,
            fixedColumns: { leftColumns: 2 },
            columns: finalColumns
        });
        categories.forEach(cat => {
            this.categoryState[cat.SafeName] = false; // false = collapsed true = expanded
        });
      
        return { dataTable, categoryColumnIndexes };
    }



   
    populateDropdowns(sites: SiteHealthMetricData[], aggregationType: 'byTrial' | 'bySite' | 'byPlatform'): void {
        const studyMap = new Map<number, string>();
        const appendixMap = new Map<number, string>();
        const siteMap = new Map<number, string>();

        sites.forEach(site => {
            if (site.StudyId !== undefined && site.Study) {
                studyMap.set(site.StudyId, site.Study);
            }
            if (site.AppendixId !== undefined && site.Appendix) {
                appendixMap.set(site.AppendixId, site.Appendix);
            }
            if (site.SiteNumber !== undefined && site.Site) {
                siteMap.set(site.SiteNumber, site.Site);
            }
        });

        const populateSelect = (selector: string, map: Map<number, string>, label: string) => {
            const $el = $(selector);
            $el.empty();
            const sortedOptions = Array.from(map.entries()).sort((a, b) => {
                const nameA = a[1].toLowerCase();
                const nameB = b[1].toLowerCase();
                return nameA.localeCompare(nameB);
            });

            sortedOptions.forEach(([id, name]) => {
                $el.append(new Option(name, id.toString(), true, true));
            });

            $el.selectpicker({
                dropupAuto: false,
                selectedTextFormat: 'count',
                countSelectedText: function (numSelected, numTotal) {
                    if (numSelected === numTotal) return `All ${label} (n=${numTotal})`;
                    return `${numSelected} of ${numTotal} selected`;
                }
            });

            $el.selectpicker('refresh');
        };

        if (aggregationType === 'byTrial') {
            populateSelect('#appendix-dropdown', appendixMap, 'Trials');
        //    populateSelect('#site-dropdown', siteMap, 'Sites');
        } else if (aggregationType === 'bySite') {
            populateSelect('#site-dropdown', siteMap, 'Sites');
        } else if (aggregationType === 'byPlatform') {
            populateSelect('#study-dropdown', studyMap, 'Platforms');
        //    populateSelect('#site-dropdown', siteMap, 'Sites');
        }
    }

    bindDropdownEvents(): void {
        $('#appendix-dropdown, #site-dropdown, #study-dropdown').on('changed.bs.select', () => {
            this.applyFilters();
        });
    }

    bindViewSwitching(): void {
        $('input[name="viewby"]').on('change', (e) => {
            const selectedView = $(e.currentTarget).attr('id');
            this.switchView(selectedView);
        });
    }

    switchView(view: string): void {
        this.selectedGrouping = view;
        
        $('#byTrialTab, #bySiteTab, #byPlatformTab').removeClass('show active');
        $('#byTrialFilter, #bySiteFilter, #byPlatformFilter').hide();
        
        if (view === 'byTrial') {
            $('#byTrialTab').addClass('show active');
            $('#byTrialFilter').show();
            if (this.tableByTrial) {
                this.tableByTrial.columns.adjust().draw(false);
            }
        } else if (view === 'bySite') {
            $('#bySiteTab').addClass('show active');
            $('#bySiteFilter').show();
            if (this.tableBySite) {
                this.tableBySite.columns.adjust().draw(false);
            }
        } else if (view === 'byPlatform') {
            $('#byPlatformTab').addClass('show active');
            $('#byPlatformFilter').show();
            if (this.tableByPlatform) {
                this.tableByPlatform.columns.adjust().draw(false);
            }
        }
    }

    getActiveTable(): any {
        if (this.selectedGrouping === 'byTrial') return this.tableByTrial;
        if (this.selectedGrouping === 'bySite') return this.tableBySite;
        if (this.selectedGrouping === 'byPlatform') return this.tableByPlatform;
        return this.tableByTrial;
    }

    getActiveCategoryIndexes(): Record<string, { compact: number[], expanded: number[] }> {
        if (this.selectedGrouping === 'byTrial') return this.categoryColumnIndexesByTrial;
        if (this.selectedGrouping === 'bySite') return this.categoryColumnIndexesBySite;
        if (this.selectedGrouping === 'byPlatform') return this.categoryColumnIndexesByPlatform;
        return this.categoryColumnIndexesByTrial;
    }


    applyFilters(): void {
        const selectedAppendices = ($('#appendix-dropdown').val() as string[] || []).map(Number);
        const selectedSites = ($('#site-dropdown').val() as string[] || []).map(Number);
        const selectedStudies = ($('#study-dropdown').val() as string[] || []).map(Number);

        if (this.selectedGrouping === 'byTrial') {
            const filteredSites = this.validSites.filter(site =>
                selectedAppendices.includes(site.AppendixId) &&
                selectedSites.includes(site.SiteNumber)
            );

            if (this.tableByTrial) {
                this.tableByTrial.clear();
                this.tableByTrial.rows.add(filteredSites);
                this.tableByTrial.draw(false);
            }

            Object.keys(this.categoryColumnIndexesByTrial).forEach(cat => {
                this.categoryState[cat] = false;
                this.categoryColumnIndexesByTrial[cat].expanded.forEach(i => this.tableByTrial.column(i).visible(false));
                this.categoryColumnIndexesByTrial[cat].compact.forEach(i => this.tableByTrial.column(i).visible(true));
            });
        } else if (this.selectedGrouping === 'bySite') {
            const filteredAggregated = this.aggregatedSites.filter(site =>
                selectedSites.includes(site.SiteNumber)
            );

            if (this.tableBySite) {
                this.tableBySite.clear();
                this.tableBySite.rows.add(filteredAggregated);
                this.tableBySite.draw(false);
            }

            Object.keys(this.categoryColumnIndexesBySite).forEach(cat => {
                this.categoryState[cat] = false;
                this.categoryColumnIndexesBySite[cat].expanded.forEach(i => this.tableBySite.column(i).visible(false));
                this.categoryColumnIndexesBySite[cat].compact.forEach(i => this.tableBySite.column(i).visible(true));
            });
        } else if (this.selectedGrouping === 'byPlatform') {
            const filteredPlatforms = this.aggregatedPlatforms.filter(site =>
                selectedStudies.includes(site.StudyId) &&
                selectedSites.includes(site.SiteNumber)
            );

            if (this.tableByPlatform) {
                this.tableByPlatform.clear();
                this.tableByPlatform.rows.add(filteredPlatforms);
                this.tableByPlatform.draw(false);
            }

            Object.keys(this.categoryColumnIndexesByPlatform).forEach(cat => {
                this.categoryState[cat] = false;
                this.categoryColumnIndexesByPlatform[cat].expanded.forEach(i => this.tableByPlatform.column(i).visible(false));
                this.categoryColumnIndexesByPlatform[cat].compact.forEach(i => this.tableByPlatform.column(i).visible(true));
            });
        }

        $('.toggle-category').removeClass('expanded').find('.toggle-icon').removeClass('rotate');

        const activeTable = this.getActiveTable();
        if (activeTable) {
            activeTable.columns.adjust().draw(false);
        }
    }

    private getBackgroundColor(
        value: number | null,
        isPercent: boolean = false,
        valueScaling: string = "Low to High",
        variableName?: string,
        scalingValue1?: number,
        scalingValue2?: number,
        scalingValue3?: number,
        scalingValue4?: number
    ): string {
        if (value === null) return "#fff";

        const cachedMinMax = variableName ? this.metricMinMaxCache.get(variableName) : null;
        const minMax = cachedMinMax ? { min: cachedMinMax.min, max: cachedMinMax.max } : null;
        const numericValue = isPercent ? value * 100 : value;
        
        if (minMax && isPercent) {
            minMax.min = 0;// minMax.min * 100;
            minMax.max = 100;// minMax.max * 100;
        }
        
        if (isPercent && scalingValue1 !== null && scalingValue1 !== undefined) scalingValue1 = scalingValue1 * 100;
        if (isPercent && scalingValue2 !== null && scalingValue2 !== undefined) scalingValue2 = scalingValue2 * 100;
        if (isPercent && scalingValue3 !== null && scalingValue3 !== undefined) scalingValue3 = scalingValue3 * 100;
        if (isPercent && scalingValue4 !== null && scalingValue4 !== undefined) scalingValue4 = scalingValue4 * 100;
        
        const thresholdCount = [scalingValue1, scalingValue2, scalingValue3, scalingValue4]
            .filter(v => v !== null && v !== undefined).length;

        let score: number;

        if (thresholdCount === 0) {
            //// No thresholds: use data min/max
            //// Exists only as a fallback...updating to make at least 2 thresholds required
            if (minMax && minMax.max !== minMax.min) {
                const normalized = (numericValue - minMax.min) / (minMax.max - minMax.min);
                score = valueScaling === "High to Low" ? normalized : 1 - normalized;
            } else {
                // just use 0-100 range if no min/max available
                score = valueScaling === "High to Low" 
                    ? Math.min(Math.max(numericValue / 100, 0), 1)
                    : 1 - Math.min(Math.max(numericValue / 100, 0), 1);
            }
        } else if (thresholdCount === 1) {
            //// 1 threshold: use as transitionPoint, data min/max as extremes
            //// Exists only as a fallback...updating to make at least 2 thresholds required
            const transitionPoint = scalingValue1!;

            if (minMax) {
                if (numericValue <= transitionPoint) {
                    // Between min and transitionPoint: map to score [0, 0.5]
                    const range = transitionPoint - minMax.min;
                    score = range > 0 ? ((numericValue - minMax.min) / range) * 0.5 : 0.5;
                } else {
                    // Between transitionPoint and max: map to score [0.5, 1]
                    const range = minMax.max - transitionPoint;
                    score = range > 0 ? 0.5 + ((numericValue - transitionPoint) / range) * 0.5 : 0.5;
                }
                if (valueScaling === "Low to High") {
                    score = 1 - score;
                }
            } else {
                // Fallback
                score = numericValue <= transitionPoint ? 0 : 1;
                if (valueScaling === "Low to High") {
                    score = 1 - score;
                }
            }
        } else if (thresholdCount === 2) {
            // 2 thresholds: linear from min (red) to max (green), white at midpoint
            const min = scalingValue1!;
            const max = scalingValue2!;
            
            if (numericValue <= min) {
                score = 0;
            } else if (numericValue >= max) {
                score = 1;
            } else {
                score = (numericValue - min) / (max - min);
            }
            
            if (valueScaling === "Low to High") {
                score = 1 - score;
            }
        } else if (thresholdCount === 3) {
            // 3 thresholds: min (red) -> midpoint (white) -> max (green)
            const min = scalingValue1!;
            const mid = scalingValue2!;
            const max = scalingValue3!;
            
            if (numericValue <= min) {
                score = 0;
            } else if (numericValue <= mid) {
                // Between min and mid: 0 to 0.5
                score = ((numericValue - min) / (mid - min)) * 0.5;
            } else if (numericValue <= max) {
                // Between mid and max: 0.5 to 1
                score = 0.5 + ((numericValue - mid) / (max - mid)) * 0.5;
            } else {
                score = 1;
            }
            
            if (valueScaling === "Low to High") {
                score = 1 - score;
            }
        } else if (thresholdCount === 4) {
            // 4 thresholds: v1->v2 (red->white), v2->v3 (white), v3->v4 (white->green)
            const v1 = scalingValue1!;
            const v2 = scalingValue2!;
            const v3 = scalingValue3!;
            const v4 = scalingValue4!;
            
            if (numericValue <= v1) {
                score = 0;
            } else if (numericValue <= v2) {
                // v1 to v2: score 0 to 0.33
                score = ((numericValue - v1) / (v2 - v1)) * 0.33;
            } else if (numericValue <= v3) {
                // v2 to v3: stay at 0.5 (white)
                score = 0.5;
            } else if (numericValue <= v4) {
                // v3 to v4: score 0.67 to 1
                score = 0.67 + ((numericValue - v3) / (v4 - v3)) * 0.33;
            } else {
                score = 1;
            }
            
            if (valueScaling === "Low to High") {
                score = 1 - score;
            }
        } else {
            // Shouldn't happen, but fallback
            score = 0.5;
        }

        return this.interpolateRedWhiteGreen(score);
    }

    private interpolateRedWhiteGreen(score: number): string {

        let r: number, g: number, b: number;

        const red = { r: 240, g: 125, b: 125 };
        const green = { r: 127, g: 184, b: 127 };
        const white = { r: 255, g: 255, b: 255 };

        if (score < 0.5) {

            const t = score / 0.5;
            r = Math.round(red.r + (white.r - red.r) * t);
            g = Math.round(red.g + (white.g - red.g) * t);
            b = Math.round(red.b + (white.b - red.b) * t);
        } else {

            const t = (score - 0.5) / 0.5;
            r = Math.round(white.r + (green.r - white.r) * t);
            g = Math.round(white.g + (green.g - white.g) * t);
            b = Math.round(white.b + (green.b - white.b) * t);
        }

        return `rgb(${r},${g},${b})`;
    }

    private populateNames(sites: any[], siteInfoList: SiteInfo[], aggregationType: 'nogroup' | 'bysite' | 'byplatform' = 'nogroup') {
        sites.forEach(site => {
            if (aggregationType === 'nogroup') {
                const siteObj = siteInfoList.find(s => s.SiteNumber === site.SiteNumber && s.StudyId === site.StudyId);
                site.Site = siteObj ? siteObj.getSiteNameNumber() : "Unknown site (" + SiteInfo.FormatSiteNumber(site.SiteNumber) + ")";
                site.Appendix = Appendix.GetAppendixName(site.AppendixId);
                site.Study = Study.GetStudyName(site.StudyId);
            } else if (aggregationType === 'bysite') {
                const siteObj = siteInfoList.find(s => s.SiteNumber === site.SiteNumber);
                site.Site = siteObj ? siteObj.getSiteNameNumber() : "Unknown site (" + SiteInfo.FormatSiteNumber(site.SiteNumber) + ")";
            } else if (aggregationType === 'byplatform') {
                const siteObj = siteInfoList.find(s => s.SiteNumber === site.SiteNumber && s.StudyId === site.StudyId);
                site.Site = siteObj ? siteObj.getSiteNameNumber() : "Unknown site (" + SiteInfo.FormatSiteNumber(site.SiteNumber) + ")";
                site.Study = Study.GetStudyName(site.StudyId);
            }
        });
    }

    private groupSitesByTrial(sites: SiteHealthMetricData[]): SiteHealthMetricData[] {
        const grouped: Map<number, SiteHealthMetricData[]> = new Map();
        
        sites.forEach(site => {
            if (!grouped.has(site.SiteNumber)) {
                grouped.set(site.SiteNumber, []);
            }
            grouped.get(site.SiteNumber)!.push(site);
        });

        const combinedSites: SiteHealthMetricData[] = [];

        grouped.forEach((siteList, siteNumber) => {
            if (siteList.length === 0) return;
            
            const combined = { ...siteList[0] } as SiteHealthMetricData;
            combined.Appendix = 'All Trials';
            
            const numericKeys = Object.keys(combined).filter(
                k => typeof (combined as any)[k] === "number" && 
                    k !== 'SiteNumber' && k !== 'StudyId' && k !== 'AppendixId' && k !== 'Id'
            );
            
            numericKeys.forEach(key => {
                const values = siteList.map(s => (s as any)[key]).filter(v => v !== null && v !== undefined);
                (combined as any)[key] = values.length > 0 ? values.reduce((a, b) => a + b, 0) / values.length : null;
            });

            combinedSites.push(combined);
        });

        return combinedSites;
    }

    private groupSitesByPlatform(sites: SiteHealthMetricData[]): SiteHealthMetricData[] {
        const grouped: Map<string, SiteHealthMetricData[]> = new Map();
        
        sites.forEach(site => {
            const key = `${site.SiteNumber}-${site.StudyId}`;
            if (!grouped.has(key)) {
                grouped.set(key, []);
            }
            grouped.get(key)!.push(site);
        });

        const combinedPlatforms: SiteHealthMetricData[] = [];

        grouped.forEach((siteList, key) => {
            if (siteList.length === 0) return;
            
            const combined = { ...siteList[0] } as SiteHealthMetricData;
            combined.Appendix = 'All Trials';
            
            const numericKeys = Object.keys(combined).filter(
                k => typeof (combined as any)[k] === "number" && 
                    k !== 'SiteNumber' && k !== 'StudyId' && k !== 'AppendixId' && k !== 'Id'
            );
            
            numericKeys.forEach(key => {
                const values = siteList.map(s => (s as any)[key]).filter(v => v !== null && v !== undefined);
                (combined as any)[key] = values.length > 0 ? values.reduce((a, b) => a + b, 0) / values.length : null;
            });

            combinedPlatforms.push(combined);
        });

        return combinedPlatforms;
    }

}
